var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import ProductImage from '../../Image/components/ProductImage';
import DotList from '../../Structure/DotList';
import { ListItemContainer, ListItemInfoContainer, ListItemImageContainer, ListItemDescriptionDotListContainer } from '../ListItem.styles';
const PricingDescriptionContainer = styled.div `
    display: flex;
`;
const ProductPricing = styled.div `
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
    color: ${(props) => props.theme.colors.success};
    margin-top: 0.5rem;
    margin-right: 1rem;
`;
const ProductListItem = (_a) => {
    var { image, title, pricing, description, children } = _a, otherProps = __rest(_a, ["image", "title", "pricing", "description", "children"]);
    return (React.createElement(ListItemContainer, Object.assign({ tabIndex: 0, role: "button", "aria-disabled": false }, otherProps),
        React.createElement(ListItemImageContainer, null,
            React.createElement(ProductImage.Small, { image: image, "aria-label": title })),
        React.createElement(ListItemInfoContainer, null,
            title ? React.createElement("h4", null, title) : null,
            React.createElement(PricingDescriptionContainer, null,
                pricing ? React.createElement(ProductPricing, null, pricing) : null,
                description ? (React.createElement(DotList, { styledComponentOverride: ListItemDescriptionDotListContainer }, description)) : null)),
        children));
};
export default ProductListItem;
//# sourceMappingURL=index.js.map